import React, { Component } from 'react'
import { withStyles, Drawer, Typography, TextField, Button, AppBar, Toolbar } from '@material-ui/core';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    }
})

class DepartmentAdd extends Component {
    constructor(props) {
        super(props);

        this.state = this.getDefaultState();

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getDefaultState() {
        return {
            dept_code: '',
            dept_name: '',
            dept_name_as: '',
            stream: '',
            admin_email: ''
        };
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data
            })
        } else {
            this.setState(this.getDefaultState())
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.edit !== this.props.edit || prevProps.show !== this.props.show || prevProps.edit_data !== this.props.edit_data) {
            if (this.props.edit) {
                this.setState({
                    ...this.getDefaultState(),
                    ...this.props.edit_data
                })
            } else {
                this.setState(this.getDefaultState())
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = {
            dept_code: this.state.dept_code,
            dept_name: this.state.dept_name,
            dept_name_as: this.state.dept_name_as,
            stream: this.state.stream,
            admin_email: this.state.admin_email
        };

        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);
            this.setState(this.getDefaultState())
        }

    }

    onDeleteClick(id){
        this.props.onDeleteClick(id);
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit Department" : "Add Department"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>
                            <TextField
                                label="Department Code"
                                name="dept_code"
                                className={classes.textField}
                                type="text"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.dept_code}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="Department Name"
                                className={classes.textField}
                                type="text"
                                name="dept_name"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.dept_name}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="Department Name in Assamese"
                                className={classes.textField}
                                type="text"
                                name="dept_name_as"
                                margin="normal"
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.dept_name_as}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="Stream"
                                className={classes.textField}
                                type="text"
                                name="stream"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.stream}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="Department Admin Email"
                                className={classes.textField}
                                type="email"
                                name="admin_email"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.admin_email}
                                onChange={this.onChange}
                            />

                            <br />
                            <div>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                    <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this,this.props.edit_data.dept_code)}
                                            >
                                            Delete
                                    </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(DepartmentAdd)


// WEBPACK FOOTER //
// ./src/Components/Master/Department/DepartmentAdd.js